<template>
  <span v-if="contact">
    <template v-if="contact.do_not_contact">
      <div class="label alert">Do Not Contact</div>
    </template>
    <template v-else>
      <button class="button warning" @click="startCallModal" v-if="activeDialerSessionUser">
        <span class="fas fa-phone"></span> Active Session
      </button>
      <button class="button primary" @click="openLogCallModal" v-else-if="activeDialerSessionContactByContact">
        <span class="fas fa-phone-slash"></span> Talking to {{ activeDialerSessionContactByContact.dialerSession.user.first_name }}
      </button>
      <button class="button primary" @click="openLogCallModal" v-else-if="recentCallId">
        <span class="fas fa-history"></span> Recent Call
      </button>
      <button class="button success" @click="startCallModal" v-else>
        <span class="fas fa-phone"></span> Start Call
      </button>
    </template>

    <log-call-modal :call-id="logCallModalCallId" :contact="contact" ref="logCallModal" v-if="logCallModalCallId" />
  </span>
</template>

<script>
import {
  activeDialerSessionContactByContactQuery,
  activeDialerSessionContactByContactUpdateSubscription,
  activeDialerSessionUserQuery
} from '../../graphql/dialerSessions'
import { DialerBus } from '../../dialer'
import LogCallModal from '../../components/LogCall/LogCallModal'
import { webSocketStatus } from '../../apollo'

export default {
  components: {
    LogCallModal
  },
  props: {
    contact: Object,
    contactsQueue: Array,
    contactsQueueContext: Object
  },
  data () {
    return {
      recentCallId: null,
      logCallModalCallId: null
    }
  },
  apollo: {
    activeDialerSessionUser: {
      query: activeDialerSessionUserQuery
    },
    activeDialerSessionContactByContact: {
      query: activeDialerSessionContactByContactQuery,
      fetchPolicy: 'network-only',
      variables () {
        return {
          contactId: this.contact.id
        }
      },
      result () {
        // keep the recent call id up to data, so we can edit the call even after the active connection data is deleted
        if (this.activeDialerSessionContactByContact && this.activeDialerSessionContactByContact.call_id) {
          this.recentCallId = this.activeDialerSessionContactByContact.call_id
        }
      },
      skip () {
        // skip if this user is the one on the call session.
        // we don't want to show the "recent call" button after the user ends their own call session,
        // because that will block their button for restarting a new call session
        return !this.contact || this.activeDialerSessionUser
      },
      subscribeToMore: {
        document: activeDialerSessionContactByContactUpdateSubscription,
        variables () {
          return {
            contactId: this.contact.id
          }
        },
        // Mutate the previous result
        updateQuery: (previousResult, { subscriptionData }) => {
          const newResult = subscriptionData.data.activeDialerSessionContactByContactUpdate
          const newConnection = newResult ? newResult.dialerSessionContact : null
          // return the new data result as the main data result
          return { activeDialerSessionContactByContact: newConnection }
        },
        skip () {
          return !this.contact || this.activeDialerSessionUser
        }
      }
    }
  },
  computed: {
    webSocketConnected () {
      return webSocketStatus.isConnected()
    }
  },
  methods: {
    async openLogCallModal () {
      // set the latest recent call to the modal
      if (!this.logCallModalCallId || this.logCallModalCallId !== this.recentCallId) {
        this.logCallModalCallId = this.recentCallId
      }
      // open the modal after the ref has time to create
      await this.$nextTick()
      this.$refs.logCallModal.openModal()
    },
    startCallModal () {
      DialerBus.setContact(this.contact)
      DialerBus.openDialer()
    },
    setDialerContact (contact) {
      // when the contact updates, send the contact to the dialer
      if (contact) {
        DialerBus.setContact(contact)
      }
    },
    startStopPollingQueries () {
      // increase the polling interval speed if the websocket disconnects
      if (this.webSocketConnected) {
        this.$apollo.queries.activeDialerSessionContactByContact.stopPolling()
      } else {
        this.$apollo.queries.activeDialerSessionContactByContact.startPolling(4000)
      }
    },
    setContactsQueueFromProps () {
      DialerBus.setContactsQueue(this.contactsQueue, this.contactsQueueContext)
    }
  },
  watch: {
    contact (newValue) {
      // update the dialer contact when the contact value changes
      this.setDialerContact(newValue)
    },
    contactsQueue (newValue) {
      this.setContactsQueueFromProps()
    },
    contactsQueueContext (newValue) {
      this.setContactsQueueFromProps()
    },
    webSocketConnected (newValue) {
      this.startStopPollingQueries()
    }
  },
  async mounted () {
    // set the dialer contact
    this.setDialerContact(this.contact)
    // set the list
    this.setContactsQueueFromProps()
  },
  created () {
    // start/stop the polling query on load
    this.startStopPollingQueries()
  }
}
</script>
